var Glyphicon = require("components/utility/icons/Glyphicon");

class ButtonDropdownOption extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onClick(e) {
		$wr.nope(e)
		// Pass on the event any, since legacy code preventDefault manually
		this.props.onClick(e);
	}

	render() {
		if (this.props.icon) {
			var icon = <Glyphicon icon={ this.props.icon } />;
		}

		if (this.props.bold) {
			var style = { fontWeight: 'bold' };
		}

		return (
			<li className={ this.props.className }>
				<a className="ellipsisText" href="#" onClick={ this.onClick } ref="link">
					<span style={ style }>
						{ icon }
						{ this.props.text }
						{ this.props.children }
					</span>
				</a>
			</li>
		);
	}

	componentDidMount() {
		if (this.props.preventCollapse) {
			this.refs.link.addEventListener("click", (e) => {
				$wr.nope(e)
				e.stopPropagation();

				if (this.props.onClick) {
					this.props.onClick();
				}
			}, false);
		}
	}
};

ButtonDropdownOption.propTypes = StrictPropTypes({
	// Text to show on option
	text: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object
	]),

	children: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.string,
		PropTypes.object
	]),

	// If true, menu won't automatically collapse when an option is selected
	preventCollapse: PropTypes.bool,

	// Glyphicon to show next to the option
	icon: PropTypes.string,

	// Makes the option show in bod
	bold: PropTypes.bool,

	// Class to add to the option's li
	className: PropTypes.string,

	// Function to call when the option is clicked on
	onClick: PropTypes.func,

	// Value of option
	value: PropTypes.string,

});

module.exports = ButtonDropdownOption;



// WEBPACK FOOTER //
// ./modules/components/utility/ButtonDropdownOption.js